import { useState } from 'react';
import { safeGetItem, safeSetItem } from 'utils/storage';

function useLocalStorage<T extends string | number | boolean>(
  key: string,
  initialValue?: T,
): [T | undefined, (value: unknown) => void] {
  const [storedValue, setStoredValue] = useState<T | undefined>(() => {
    if (typeof window === 'undefined') return initialValue;
    return safeGetItem<T | undefined>(key, initialValue);
  });

  const setValue = (value: unknown) => {
    try {
      setStoredValue(value as T | undefined);
      if (typeof window !== 'undefined') {
        safeSetItem(key, value);
      }
    } catch (error) {
      console.error('[useLocalStorage] setValue failed', error);
    }
  };

  return [storedValue, setValue];
}

export default useLocalStorage;
